import BaseService from '@/services/base_service';
import Axios from 'axios';

export default class PageService extends BaseService {

  async list(params) {
    try {
      return await axios.get('/pagina', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id) {
    try {
      return await axios.get('/pagina/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model) {

    try {
      return await axios.post('pagina/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/pagina/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/pagina/' + id);
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/page.js